import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
    selector: 'suspended-menu',
    templateUrl: './suspended-menu.component.html',
    styleUrls: ['./suspended-menu.component.scss'],
    animations: [trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ]),
        trigger('listAnimation', [
            transition('* => *', [
                query(':leave', [
                    stagger(0, [
                        animate('0.1s', style({ opacity: 0 }))
                    ])
                ], { optional: true }),
                query(':enter', [
                    style({ opacity: 0 }),
                    stagger(100, [
                        animate('0.3s', style({ opacity: 1 }))
                    ])
                ], { optional: true })
            ])
        ])
    ],
    standalone: false
})
export class SuspendedMenuComponent {

  @Input() show = true;
  @Input() title = 'Sem Título';
  @Input() data = [];
  @Input() dropprefix='';
  @Input() dropsufix='';
  @Input() heigth:string;
  
  
  constructor() { }
  
  drag(event: any) {
    
    const value = event.target.dataset.value;
    let item = event.target.dataset.dragData;
    item = this.dropprefix + item + this.dropsufix;
    event.dataTransfer.setData('text/plain', item);
  }


}
